import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { AuthStore } from '@yoshu-lib/core/auth/auth.store'

export const groupGuard =
  (requiredGroups: string | string[]): CanActivateFn =>
  () => {
    const authStore = inject(AuthStore)
    const router = inject(Router)

    const required = Array.isArray(requiredGroups) ? requiredGroups : [requiredGroups]
    const hasGroup = required.some((group) => authStore.hasGroup(group))

    if (!hasGroup) {
      router.navigate(['/'])
      return false
    }

    return true
  }
